export default __webpack_public_path__ + "static/media/Find-Patient.288c5293.svg";